import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IClaimConfiguration } from './claimConfiguration'
import { IClaimConfigurationItemTransformationType } from './claimConfigurationItemTransformationType'
import { ODataService } from 'common-services'

export interface IClaimConfigurationItem extends IModelBase {
  ClaimConfigurationId: number
  ClaimConfiguration: IClaimConfiguration
  ParentSegmentId: string
  ParentQualifierId: string
  SegmentId: string
  Qualifier: string
  ElementId: number
  Value: string
  TransformationTypeId: number
  ClaimConfigurationItemTransformationType: IClaimConfigurationItemTransformationType
}

@Injectable()
export class ClaimConfigurationItemODataService extends ODataService<IClaimConfigurationItem> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimConfigurationItems'
  }
}
